'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    PaginatedStoreUtils = require('../utils/PaginatedStoreUtils'),
    UserStore = require('./UserStore'),
    { createIndexedListStore, createListActionHandler } = PaginatedStoreUtils;

var UserSubscriptionsStore = createIndexedListStore({
  getUserSubscriptions(userId) {
    return this.getIds(userId).map(UserStore.get);
  }
});

function getList(userId) {
  return UserSubscriptionsStore.getList(userId);
}

function emitChange() {
  UserSubscriptionsStore.emitChange();
}

var handleListAction = createListActionHandler({
  request: ActionTypes.REQUEST_USER_SUBSCRIPTIONS,
  error: ActionTypes.REQUEST_USER_SUBSCRIPTIONS_ERROR,
  success: ActionTypes.REQUEST_USER_SUBSCRIPTIONS_SUCCESS
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([UserStore.dispatchToken]);

  var action = payload.action,
      userId = action.userId;

  if (userId) {
    handleListAction(action, getList(userId), emitChange);
  }

  switch (action.type) {
  case ActionTypes.FOLLOW_USER_SUCCESS:
    getList(UserStore.getMe().id).prepend(action.userId);
    emitChange();
    break;

  case ActionTypes.UNFOLLOW_USER_SUCCESS:
    getList(UserStore.getMe().id).remove(action.userId);
    emitChange();
    break;

  case ActionTypes.INVALIDATE_USER_SUBSCRIPTIONS:
    getList(action.userId).invalidate();
    break;
  }
});

module.exports = UserSubscriptionsStore;


/** WEBPACK FOOTER **
 ** ./stores/UserSubscriptionsStore.js
 **/